import objectTypes from '../../constants/ObjectTypes';
import constants from '../../qti/Constants';

const imageService = {
    shouldUseModelSize(useModelWidthAndHeight, questionObjectType, width, height) {
        return (useModelWidthAndHeight || questionObjectType === objectTypes.GRAPHIC_TEXT_ENTRY) && !!width && !!height;
    },

    shouldUseRecommendedMaxHeight(maxHeight) {
        return maxHeight === constants.maxHeightOptions.RECOMMENDED;
    },
};

export default imageService;
